<div class="wrapper">
  <input type="text" placeholder="code" formControlName="code" (keyup.enter)="onPressEnter()" />
  <icon name="ph:key-fill" color="primary-color" size="24" />
</div>
